import {Component, Inject, OnInit} from '@angular/core';
import {User} from '../../../data/models/user';
import {UserService} from '../../../services/api/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-user-block-dialog',
  templateUrl: './user-block-dialog.component.html',
  styleUrls: ['./user-block-dialog.component.css']
})
export class UserBlockDialogComponent implements OnInit {

  user: User;

  constructor(
    private userService: UserService,
    private dialogRef: MatDialogRef<UserBlockDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      user: User,
    },
  ) {
    this.user = data.user;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.userService.blockUser(this.user.id)
      .then(user => {
        this.dialogRef.close(user);
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
